<template>
  <div class="main">
    <burger :is-opened="menuClicked" v-on:menu-toggle="menuClicked = !menuClicked"></burger>
    <div class="c-toc__wrapper page-wrap">
      <book-topbar v-on:burger-clicked="menuClicked = !menuClicked" :connection="connection" />
      <section class="c-toc__text-container">
        <h1 class="c-toc__heading">{{ $t('TERMS_AND_CONDITIONS') }}</h1>
        <div>
          Text here...
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import { setDocumentTitle } from '@/utils/utils'

import BookTopbar from '@/components/BookTopBar'
import BurgerMenu from '@/components/BurgerMenu'

export default {
  name: 'TOC',

  components: {
    'book-topbar': BookTopbar,
    'burger': BurgerMenu
  },

  data () {
    return {
      menuClicked: false
    }
  },

  computed: {
    ...mapState('userSettings', {
      connection: state => state.connection
    })
  },

  watch: {
    ['$i18n.locale']() {
      setDocumentTitle(this.$t('TERMS_AND_CONDITIONS'))
    }
  },

  mounted() {
    setDocumentTitle(this.$t('TERMS_AND_CONDITIONS'))
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';

.c-toc__wrapper {
  padding: 50px 20px 50px !important;
  display: flex;
  justify-content: space-between;
  color: $dark-blue;
}

.c-toc__heading {
  font-size: 1.3em;
  font-weight: 700;
}

.c-toc__text-container {
  padding-top: 5em;
}
</style>
